<form class="igo-form" [formGroup]="form">
  <div class="igo-input-container">
    <mat-form-field>
      <mat-label>{{ 'igo.geo.printForm.title' | translate }}</mat-label>
      <input
        matInput
        formControlName="title"
        placeholder="{{ 'igo.geo.printForm.title' | translate }}"
      />
      @if (titleField.errors?.maxlength) {
        <mat-error>{{
          'igo.geo.formValidation.maxLength'
            | translate
              : {
                  column: 'igo.geo.printForm.title' | translate,
                  value: 130
                }
        }}</mat-error>
      }
    </mat-form-field>
  </div>
  <div class="igo-input-container">
    <mat-form-field>
      <mat-label>{{ 'igo.geo.printForm.subtitle' | translate }}</mat-label>
      <input
        matInput
        formControlName="subtitle"
        placeholder="{{ 'igo.geo.printForm.subtitle' | translate }}"
      />
      @if (subtitleField.errors?.maxlength) {
        <mat-error>{{
          'igo.geo.formValidation.maxLength'
            | translate
              : {
                  column: 'igo.geo.printForm.subtitle' | translate,
                  value: 120
                }
        }}</mat-error>
      }
    </mat-form-field>
  </div>
  <div class="igo-input-container">
    <mat-form-field>
      <mat-label>{{ 'igo.geo.printForm.comment' | translate }}</mat-label>
      <input
        matInput
        formControlName="comment"
        placeholder="{{ 'igo.geo.printForm.comment' | translate }}"
      />
      @if (commentField.errors?.maxlength) {
        <mat-error>{{
          'igo.geo.formValidation.maxLength'
            | translate
              : {
                  column: 'igo.geo.printForm.comment' | translate,
                  value: maxLength
                }
        }}</mat-error>
      }
    </mat-form-field>
  </div>

  <div class="igo-input-container slide-toggle-container">
    <div class="print-slide-toggle-container">
      <mat-slide-toggle
        class="print-option"
        formControlName="showProjection"
        [labelPosition]="'before'"
      >
        {{ 'igo.geo.printForm.showProjection' | translate }}
      </mat-slide-toggle>
      <mat-slide-toggle
        class="print-option"
        formControlName="showScale"
        [labelPosition]="'before'"
      >
        {{ 'igo.geo.printForm.showScale' | translate }}
      </mat-slide-toggle>
      <mat-slide-toggle
        class="print-option"
        formControlName="doZipFile"
        [labelPosition]="'before'"
        [style.display]="isPrintService ? 'none' : ''"
      >
        {{ 'igo.geo.printForm.doZipFile' | translate }}
      </mat-slide-toggle>
      <mat-slide-toggle
        class="print-option"
        formControlName="showNorthArrow"
        [labelPosition]="'before'"
      >
        {{ 'igo.geo.printForm.showNorthArrow' | translate }}
      </mat-slide-toggle>
    </div>
  </div>

  <div class="igo-input-container">
    <mat-form-field>
      <mat-label>{{
        'igo.geo.printForm.legendPosition' | translate
      }}</mat-label>
      <mat-select
        formControlName="legendPosition"
        placeholder="{{ 'igo.geo.printForm.legendPosition' | translate }}"
      >
        @for (
          legendPosition of legendPositions | keyvalue;
          track legendPosition
        ) {
          <mat-option [value]="legendPosition.key">
            @if (!['newpage', 'newimage'].includes(legendPosition.value)) {
              {{
                'igo.geo.printForm.legendPositions.' + legendPosition.value
                  | translate
              }}
            }
            @if (['newpage', 'newimage'].includes(legendPosition.value)) {
              {{
                (outputFormat === 'Pdf'
                  ? 'igo.geo.printForm.legendPositions.newpage'
                  : 'igo.geo.printForm.legendPositions.newimage'
                ) | translate
              }}
            }
          </mat-option>
        }
      </mat-select>
    </mat-form-field>
  </div>

  <div class="igo-input-container">
    <mat-form-field>
      <mat-label>{{ 'igo.geo.printForm.outputFormat' | translate }}</mat-label>
      <mat-select
        (selectionChange)="toggleImageSaveProp()"
        formControlName="outputFormat"
        placeholder="{{ 'igo.geo.printForm.outputFormat' | translate }}"
      >
        @for (outputFormat of outputFormats | keyvalue; track outputFormat) {
          <mat-option [value]="outputFormat.key">
            {{ outputFormat.value }}
          </mat-option>
        }
      </mat-select>
    </mat-form-field>
  </div>

  <div
    class="igo-input-container"
    [style.display]="isPrintService ? 'block' : 'none'"
  >
    <mat-form-field>
      <mat-label>{{ 'igo.geo.printForm.paperFormat' | translate }}</mat-label>
      <mat-select
        (selectionChange)="changeCommentLength()"
        formControlName="paperFormat"
        placeholder="{{ 'igo.geo.printForm.paperFormat' | translate }}"
      >
        @for (paperFormat of paperFormats | keyvalue; track paperFormat) {
          <mat-option [value]="paperFormat.key">
            {{
              'igo.geo.printForm.paperFormats.' + paperFormat.value | translate
            }}
          </mat-option>
        }
      </mat-select>
    </mat-form-field>
  </div>

  <div
    class="igo-input-container"
    [style.display]="isPrintService ? 'none' : 'block'"
  >
    <mat-form-field>
      <mat-label>{{ 'igo.geo.printForm.imageFormat' | translate }}</mat-label>
      <mat-select
        formControlName="imageFormat"
        placeholder="{{ 'igo.geo.printForm.imageFormat' | translate }}"
      >
        @for (imageFormat of imageFormats | keyvalue; track imageFormat) {
          <mat-option [value]="imageFormat.key">
            {{ imageFormat.value }}
          </mat-option>
        }
      </mat-select>
    </mat-form-field>
  </div>

  <div class="igo-input-container">
    <mat-form-field>
      <mat-label
        >{{ 'igo.geo.printForm.resolution' | translate }} ({{
          'igo.geo.printForm.resolutionUnit' | translate
        }})</mat-label
      >
      <mat-select
        formControlName="resolution"
        placeholder="{{ 'igo.geo.printForm.resolution' | translate }}"
      >
        @for (resolution of resolutions; track resolution) {
          <mat-option [value]="resolution">
            {{ resolution }}
          </mat-option>
        }
      </mat-select>
    </mat-form-field>
  </div>

  <div
    class="igo-input-container"
    [style.display]="isPrintService ? 'block' : 'none'"
  >
    <mat-form-field>
      <mat-label>{{ 'igo.geo.printForm.orientation' | translate }}</mat-label>
      <mat-select
        (selectionChange)="changeCommentLength()"
        formControlName="orientation"
        placeholder="{{ 'igo.geo.printForm.orientation' | translate }}"
      >
        @for (orientation of orientations | keyvalue; track orientation) {
          <mat-option [value]="orientation.key">
            {{ 'igo.geo.printForm.' + orientation.value | translate }}
          </mat-option>
        }
      </mat-select>
    </mat-form-field>
  </div>

  <div class="igo-form-button-group print-button-top-padding">
    <button
      matButton="elevated"
      type="button"
      [disabled]="!form.valid || (disabled$() | async)"
      (click)="handleFormSubmit(form.value, form.valid)"
    >
      {{ 'igo.geo.printForm.saveBtn' | translate }}
    </button>
  </div>
</form>
